module.exports = __webpack_public_path__ + "media/pages/assets/images/heartbeat-c3654eff1c27be32a5171ec9a51dbb31.svg";